// extracted by mini-css-extract-plugin
export default {"buyerNavWrapper":"BuyerNavbar_buyerNavWrapper__zH7IU","navContainer":"BuyerNavbar_navContainer__p0JSu","navLink":"BuyerNavbar_navLink__DZg0W","active":"BuyerNavbar_active__n35li"};